module.exports = __webpack_public_path__ + "img/xml.a83ee4db.svg";